import { apiClient } from './client';
import type { ApiResponse } from '../types/api';
import type {
  LoginRequest,
  RegisterRequest,
  AuthResponse,
  RefreshTokenRequest,
  RefreshTokenResponse,
  User,
  ChangePasswordRequest,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  UpdateProfileRequest,
  DeviceInfo,
} from '../types/auth';

export const authApi = {
  login: (data: LoginRequest, deviceInfo?: DeviceInfo): Promise<ApiResponse<AuthResponse>> =>
    apiClient.post('/auth/login', data, {
      headers: {
        'X-Client-Type': data.client_type || 'web',
        ...(deviceInfo && { 'X-Device-Info': JSON.stringify(deviceInfo) }),
      },
    }),

  register: (data: RegisterRequest): Promise<ApiResponse<AuthResponse>> =>
    apiClient.post('/auth/register', data),

  refreshToken: (data: RefreshTokenRequest): Promise<ApiResponse<RefreshTokenResponse>> =>
    apiClient.post('/auth/refresh', data),

  getProfile: (): Promise<ApiResponse<User>> =>
    apiClient.get('/auth/profile'),

  updateProfile: (data: UpdateProfileRequest): Promise<ApiResponse<User>> =>
    apiClient.put('/auth/profile', data),

  changePassword: (data: ChangePasswordRequest): Promise<ApiResponse<void>> =>
    apiClient.post('/auth/change-password', data),

  forgotPassword: (data: ForgotPasswordRequest): Promise<ApiResponse<void>> =>
    apiClient.post('/auth/forgot-password', data),

  resetPassword: (data: ResetPasswordRequest): Promise<ApiResponse<void>> =>
    apiClient.post('/auth/reset-password', data),

  logout: (): Promise<ApiResponse<void>> =>
    apiClient.post('/auth/logout'),
};
